import React, { useEffect } from 'react'
import { motion } from 'framer-motion'
import { TrendingUp, Award, Users, CheckCircle } from 'lucide-react'

const TrainingDevelopment = () => {
  const programs = [
    'Customized training programs',
    'Industry certifications',
    'Soft skills development',
    'Leadership training'
  ]

  return (
    <div>
      <section className="bg-gradient-to-br from-primary-800 via-primary-700 to-teal-700 text-white py-16 md:py-20">
        <div className="container-max">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-3xl md:text-5xl font-bold text-white mb-4">Training & Development</h1>
            <p className="text-lg md:text-xl text-primary-100">Professional development programs to enhance your team's capabilities</p>
            <div className="w-20 h-1 bg-accent-500 mx-auto mt-6 rounded-full"></div>
          </div>
        </div>
      </section>

      <section className="section-padding">
        <div className="container-max">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-primary-800 mb-6">Skills Enhancement Programs</h2>
              <p className="text-secondary-500 mb-6">Invest in your workforce with our comprehensive training and development programs. We help your team acquire new skills and advance their careers.</p>
              <ul className="space-y-3">
                {programs.map((program, index) => (
                  <li key={index} className="flex items-center">
                    <CheckCircle className="w-5 h-5 text-green-500 mr-3" />
                    <span className="text-secondary-600">{program}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <img src="https://images.unsplash.com/photo-1517180102446-f3ece451e9d8?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Training & Development" className="rounded-lg shadow-xl" />
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default TrainingDevelopment
